// extracted by mini-css-extract-plugin
export var contact = "anfragen-module--contact--w-qjy";
export var productLine = "anfragen-module--product-line--qyaT5";
export var errorMessage = "anfragen-module--error-message--2o56O";
export var section = "anfragen-module--section--3FgRj";
export var background = "anfragen-module--background--2Hx9g";
export var cartItemsList = "anfragen-module--cartItemsList--2v-n_";
export var firstHero = "anfragen-module--firstHero--27r62";
export var spinAround = "anfragen-module--spinAround--21GX2";